module.exports = __webpack_public_path__ + "img/intelligent05.b714918f.png";